<template>
  <div>

    <v-row justify="center">
      <v-col cols="8">
        <v-card>

          <v-card-title class="justify-center" style="background-color: #e6e6e6;">
            <v-icon left>mdi-cogs</v-icon>
            Proficiência do Aluno
          </v-card-title>

          <v-card-text>

            <!--                        <v-row dense class="justify-center">-->
            <!--                            <v-icon left>mdi-filter</v-icon>-->
            <!--                            <p style="margin-top: 15px; font-size: 20px;" class="font-weight-black">Selecione os-->
            <!--                                dados</p>-->
            <!--                        </v-row>-->

            <v-divider/>

            <br/>

            <v-row justify="center">
              <v-col cols="9">
                <v-select
                    :disabled="carregando || carregandoAlunos || carregandoGrafico"
                    :items="cidades"
                    item-text="nome"
                    v-model="cidadeSelecionada"
                    no-data-text="Nenhuma cidade encontrada"
                    label="Cidade"
                    @change="onOwnerChange()"
                    return-object
                    solo
                />
              </v-col>
            </v-row>

            <v-row justify="center" style="margin-top: -20px;">
              <v-col cols="9">
                <v-select
                    :disabled="carregando || carregandoAlunos || carregandoGrafico"
                    :items="avaliacoes"
                    item-text="descricao"
                    v-model="avaliacaoSelecionada"
                    no-data-text="Nenhuma avaliação encontrada"
                    label="Avaliações"
                    @change="onAvaliacaoChange()"
                    return-object
                    solo
                />
              </v-col>
            </v-row>

            <v-row justify="center" style="margin-top: -20px;">
              <v-col cols="9">
                <v-select
                    :disabled="carregando || carregandoAlunos || carregandoGrafico "
                    :items="escolas"
                    item-text="nome"
                    v-model="escolaSelecionada"
                    no-data-text="Nenhuma escola encontrada"
                    @change="onEscolaChange()"
                    return-object
                    label="Escola"
                    solo
                />
              </v-col>
            </v-row>

            <v-row justify="center" style="margin-top: -20px;">
              <v-col cols="9">
                <v-select
                    :disabled="carregando || carregandoAlunos || carregandoGrafico"
                    :items="turmas"
                    item-text="turma"
                    v-model="turmaSelecionada"
                    no-data-text="Nenhuma turma encontrada"
                    @change="onTurmaChange()"
                    return-object
                    label="Turma"
                    solo
                />
              </v-col>
            </v-row>

            <v-row justify="center" style="margin-top: -20px;">
              <v-col cols="9">
                <v-select
                    :disabled="carregando || carregandoAlunos || carregandoGrafico"
                    :items="cadernos"
                    item-text="descricao"
                    v-model="cadernoSelecionado"
                    no-data-text="Nenhum caderno encontrada"
                    label="Cadernos"
                    return-object
                    solo
                />
              </v-col>
            </v-row>

            <v-row class="justify-center" style="margin-top: -25px;">
              <v-btn color="primary" :loading="carregandoAlunos || carregandoGrafico"
                     :disabled="cadernoSelecionado == null"
                     @click="carregarListaDeAlunos()">BUSCAR ALUNOS
              </v-btn>
            </v-row>

          </v-card-text>

        </v-card>
      </v-col>
    </v-row>

    <v-dialog max-width="750" v-model="dialogListaDeAlunos" scrollable>

      <v-card>

        <v-card-title style="background-color: #e6e6e6;" class="justify-center">
          <v-icon left>list</v-icon>
          Alunos
        </v-card-title>

        <v-card-text>
          <v-data-table
              v-model="alunosSelecionados"
              :footer-props="footerProps"
              :items="alunos"
              :headers="alunosHeaders"
              item-key="id"
              show-select
              fixed-header
              height="500"
          >

          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn dark color="primary"
                 :loading="carregandoAlunos || carregandoGrafico"
                 @click="gerarRelatorio()">
            <v-icon
                right
                dark
            >
              mdi-file-chart
            </v-icon>
            GERAR RELATÓRIO
          </v-btn>

<!--          <v-btn color="primary"-->
<!--                 :loading="carregandoAlunos || carregandoGrafico"-->
<!--                 :disabled="cadernoSelecionado.provaId == null"-->
<!--                 @click="downloadReforco()">-->
<!--            <v-icon-->
<!--                right-->
<!--                dark-->
<!--            >-->
<!--              mdi-download-->
<!--            </v-icon>-->
<!--            REFORÇO-->
<!--          </v-btn>-->
        </v-card-actions>

      </v-card>

    </v-dialog>

  </div>
</template>

<script>

import RelatorioService from "../../service/RelatorioService";
import ArquivoService from "../../service/ArquivoService";
import _ from "lodash"

export default {
  data() {
    return {

      footerProps: {
        itemsPerPageText: "Itens por página:",
        itemsPerPageOptions: [50]
      },
      alunosHeaders: [
        {
          text: "ID",
          value: "id",
          align: "center"
        },
        {
          text: "Nome",
          value: "nome",
          align: "center"
        },
        {
          text: "RA",
          value: "ra",
          align: "center"
        },
      ],
      alunos: [],
      alunosSelecionados: [],

      cidades: [],
      cidadeSelecionada: null,

      avaliacoes: [],
      avaliacaoSelecionada: null,

      escolas: [],
      escolaSelecionada: null,

      turmas: [],
      turmaSelecionada: "",

      cadernos: [],
      cadernoSelecionado: {},

      allData: [],

      carregando: false,
      carregandoAlunos: false,
      carregandoGrafico: false,
      dialogListaDeAlunos: false,

    }
  },
  methods: {

    graficos() {
      this.$router.push('/graficos')
    },

    findOwners() {
      this.carregando = true;
      RelatorioService.findOwners()
          .then(({data}) => {
            this.cidades = data;
            this.cidadeSelecionada = this.cidades[0];
            this.onOwnerChange();
          })
          .finally(() => {
            this.carregando = false;
          })
    },

    onOwnerChange() {
      this.carregando = true;
      RelatorioService.findAvaliacoes(this.cidadeSelecionada.id)
          .then(({data}) => {
            this.avaliacoes = data;
          })
          .finally(() => {
            this.carregando = false;
          })
    },

    onAvaliacaoChange() {
      this.carregando = true;
      this.alunosSelecionados = [];
      RelatorioService.findEscolasByAvaliacao(this.avaliacaoSelecionada.id)
          .then(({data}) => {
            this.escolas = data;
            this.escolaSelecionada = null;
            this.turmaSelecionada = null;
            this.cadernoSelecionado = null;
          })
          .finally(() => {
            this.carregando = false;
          })
    },

    onEscolaChange() {
      this.alunosSelecionados = [];
      RelatorioService.findTurmasByEscola(this.escolaSelecionada.id, this.avaliacaoSelecionada.id)
          .then(({data}) => {
            this.allData = data;
            this.turmaSelecionada = null;
            this.cadernoSelecionado = null;

            this.turmas = _.map(this.allData, function (t) {
              return {
                id: t.idturma,
                turma: t.turma
              }
            });
            this.turmas = _.uniqBy(this.turmas, 'id');
          })
          .finally(() => {
            this.carregando = false;
          })
    },

    onTurmaChange() {

      let self = this;
      this.alunosSelecionados = [];

      console.log(self.turmaSelecionada.id)
      console.log(this.allData)

      this.cadernos = _.filter(this.allData, function (d) {
        return d.idturma == self.turmaSelecionada.id
      });

      this.cadernos = _.map(this.cadernos, function (c) {
        return {
          id: c.idcaderno,
          descricao: c.descricao,
          provaId: c.provaid
        }
      });
      this.cadernoSelecionado = null;
    },

    carregarListaDeAlunos() {
      this.carregandoAlunos = true;
      RelatorioService.findAlunosByTurmaAndAvaliacao(this.avaliacaoSelecionada.id, this.turmaSelecionada.id, this.cadernoSelecionado.id)
          .then(({data}) => {
            this.alunos = data;
            this.dialogListaDeAlunos = true;
          })
          .finally(() => {
            this.carregandoAlunos = false;
          })
    },

    gerarRelatorio() {

      this.carregandoGrafico = true;

      let idAlunos = _.map(this.alunosSelecionados, (a) => {
        return a.id;
      });

      let alunosFilter = {
        idOwner: this.cidadeSelecionada.id,
        idCaderno: this.cadernoSelecionado.id,
        idAvaliacao: this.avaliacaoSelecionada.id,
        idAlunos: idAlunos,
        type: 'Aluno'
      };

      let routeData = this.$router.resolve({name: 'MainRelatorio', query: alunosFilter});
      window.open("/relatorio"+routeData.href.replace('/', ''), '_blank');
      this.carregandoGrafico = false;
    },

    downloadReforco() {
      ArquivoService.downloadById(this.cadernoSelecionado.provaId)
          .then(response => {
            let buffer = ArquivoService.base64ToArrayBuffer(response.data);
            ArquivoService.saveByteArray("reforco", buffer, "application/pdf");
          });
    }

  },

  created() {
    this.findOwners();
  }

}
</script>

<style>

</style>
